import React from "react";
import EntityEmptyPage from "components/Records/NewRecordPages/EntityEmptyPage";
import AddDirectMailPopup from "./AddDirectMailPopup";


interface DirectMailEmptyPageProps {
  onDirectMailCreated?: (newDirectMail: any) => void;
}


export default function DirectMailEmptyPage({
  onDirectMailCreated,
}: DirectMailEmptyPageProps) {
  return (
    <EntityEmptyPage
      title="Direct Mail"
      colorKey="interactions"
      AddPopupComponent={AddDirectMailPopup}
      onEntityCreated={onDirectMailCreated}
      items={[
        {
          id: "select",
          type: "text",
          text: "Select a Direct Mail",
          direction: "left",
        },
        {
          id: "create",
          type: "button",
          label: "Create New Direct Mail",
          openPopup: true, 
        },
        {
          id: "send",
          type: "text",
          text: "Send DirectMail",
          direction: "right",
        },
        {
          id: "details",
          type: "text",
          text: "View Direct Mail History",
          direction: "down",
        },
      ]}
    />
  );
}
